<template>
    <div class="new-page-main" :style="dataDetailStyle">
        <!--搜索查询栏-->
        <dt-search-bar style="padding:20px 5px 5px;">
            <template slot="filterSlot">
                <data-filter
                        ref="dataFilterRef"
                        :timeData="timeData"
                        :schoolId="''"
                        :searchParams="searchParams"
                        :contentObject="contentObject"
                        :buttonColor="'#00CAAF'"
                        @filter-data="filterData"
                ></data-filter>
            </template>
            <template slot="buttonSlot">
                <div style="display: flex;float: right;">
                    <!--搜索框-->
                    <div class="big-data-search-input" v-if="activeType=='school'">
                        <input placeholder="支持学校姓名关键字搜索" class="big-data-input-cla" v-model="keyWord"
                               v-on:keyup.enter="handleSearch"/>
                        <div class="big-data-search-btn" v-on:click="handleSearch">
                            <div class="big-data-search-icon">
                                <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                     height="100%"/>
                            </div>
                        </div>
                    </div>
                    <!--导出按钮-->
                    <div v-if="tabsName=='resTab'" v-on:click="exportInfoToExcel" class="export-btn">列表导出</div>
                </div>
            </template>
        </dt-search-bar>
        <!--数据展示切换-->
        <div class="data-tab-area">
            <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                <TabPane label="资源详情" name="resTab"></TabPane>
                <TabPane label="微课详情" name="microTab"></TabPane>
                <TabPane label="作业详情" name="hwTab"></TabPane>
                <TabPane label="探究学习详情" name="studyTab"></TabPane>
            </Tabs>
        </div>
        <div>
            <!--数据统计图-->
            <div class="data-statistics-img" ref="dataStatistics">
                <ul>
                    <template v-for="(item,index) in dataSummaryMap">
                        <data-statis-summary
                                :num="item.value"
                                :text="item.key"
                                :remindText="item.remindText"
                        ></data-statis-summary>
                    </template>
                </ul>
            </div>
            <!--作业详情-->
            <school-homework-data-table
                    v-if="isFilterReady&&tabsName=='hwTab'"
                    ref="hwTabRef"
                    :activeType="activeType"
                    :schoolId="schoolId"
                    :schoolName="$route.query.schoolName"
                    :keyWord="keyWord"
                    :filters="filters"
            ></school-homework-data-table>
            <!--微课详情-->
            <school-micro-data-table
                    v-if="isFilterReady&&tabsName=='microTab'"
                    ref="microTabRef"
                    :activeType="activeType"
                    :schoolId="schoolId"
                    :schoolName="$route.query.schoolName"
                    :keyWord="keyWord"
                    :filters="filters"
            ></school-micro-data-table>
            <!--资源详情-->
            <school-resource-data-table
                    v-if="isFilterReady&&tabsName=='resTab'"
                    ref="resTabRef"
                    :activeType="activeType"
                    :schoolId="schoolId"
                    :schoolName="$route.query.schoolName"
                    :keyWord="keyWord"
                    :filters="filters"
            ></school-resource-data-table>
            <!--探究学习详情-->
            <school-learning-data-table
                    v-if="isFilterReady&&tabsName=='studyTab'"
                    ref="studyTabRef"
                    :activeType="activeType"
                    :schoolId="schoolId"
                    :schoolName="$route.query.schoolName"
                    :keyWord="keyWord"
                    :filters="filters"
            ></school-learning-data-table>
        </div>
    </div>
</template>

<script>
    import {
        findPhaseDataSummary,
        findSchoolDataSummary,
        findSubjectDataSummary
    } from "../../../../service/bigDataApi.js";

    const DtSearchBar = () => import('../../../../components/DtSearchBar');
    const DataFilter = () => import('../../../../components/DataFilter');
    const DataStatisSummary = () => import('../../../../components/DataStatisSummary');
    const SchoolHomeworkDataTable = () => import('../../modules/SchoolHomeworkDataTable');
    const SchoolMicroDataTable = () => import('../../modules/SchoolMicroDataTable');
    const SchoolResourceDataTable = () => import('../../modules/SchoolResourceDataTable');
    const SchoolLearningDataTable = () => import('../../modules/SchoolLearningDataTable');
    const SchoolInteractDataTable = () => import('../../modules/SchoolInteractDataTable');
    export default {
        name: "region-statis-details",
        components: {
            DtSearchBar,
            DataFilter,
            DataStatisSummary,
            SchoolHomeworkDataTable,
            SchoolMicroDataTable,
            SchoolResourceDataTable,
            SchoolLearningDataTable,
            SchoolInteractDataTable
        },
        watch: {
            'keyWord': {
                handler(newValue, oldValue) {
                    if (this.isFilterReady) {
                        this.handleSearch();
                    }
                },
                deep: true
            }
        },
        data() {
            return {
                //tab页标签
                tabsName: this.$route.query.tabCode || 'resTab',
                searchParams:{
                    gradeId: this.$route.query.gradeid==undefined?"0":this.$route.query.gradeId,
                    phase: this.$route.query.phase==undefined?"0":this.$route.query.phase
                },
                //数据概览
                dataSummaryMap: [],
                //日期集合
                timeData: [
                    {
                        key: 0,
                        value: '全部'
                    }, {
                        key: 1,
                        value: '近一周'
                    }, {
                        key: 2,
                        value: '近一月'
                    }, {
                        key: 3,
                        value: '自定义'
                    }
                ],
                schoolId: this.$route.query.schoolId,
                keyWord: '',
                filters:{},
                isFilterReady: false,
                //动态配置搜索框中的组件是否显示
                contentObject: {
                    //是否显示时间切换按钮
                    displayTimeFilter: true,
                    // //是否显示学科下拉框
                    displaySubjectFilter: this.$route.query.activeType == 'subject' ? true : false,
                    // //是否显示年级下拉框
                    // displayGradeFilter: this.$route.query.activeType == 'phase' ? true : false,
                    //是否显示年级下拉框
                    displayGradeFilter: false,
                    //是否显示班级下拉框
                    displayClassFilter: false,
                    //是否显示学年下拉框
                    displayYearFilter: true,
                    //是否显示学段下拉框
                    displayPhaseFilter:true
                },
                //表格高度
                dataDetailStyle: {
                    height: '883px'
                },
                //活跃场景类型：学段、学校、学科
                activeType: this.$route.query.activeType,
                //活跃场景名称
                activeTypeName: this.$route.query.activeTypeName
            }
        },
        created() {
            this.syncAgentContext();
            this.setCurrentPath();
        },
        methods: {
            syncAgentContext() {
                const { agentId, agentName } = this.$route.query;
                if (agentId) {
                    this.$store.commit("SET_AGENTID", agentId);
                }
                if (agentName) {
                    this.$store.commit("SET_AGENTName", agentName);
                }
            },
            /**
             * 面包屑
             */
            setCurrentPath() {
                let currentPathArr;
                currentPathArr = [
                    {
                        title: "首页",
                        path: "regiondataboard",
                        name: "regiondataboard",
                        query: {
                            agentId: this.$route.query.agentId || this.$store.getters.agentId,
                            agentName: this.$route.query.agentName || this.$store.getters.agentName
                        }
                    },
                    {
                        title: this.$route.query.activeTypeName,
                        path: "",
                        name: "regionstatisdetails"
                    }
                ];
                this.$store.commit("setCurrentPath", currentPathArr);
            },
            /**
             * 导出产品信息
             */
            exportInfoToExcel() {
                const resTabRef = this.$refs.resTabRef;
                const params = {
                    agentId: this.$route.query.agentId || this.$store.getters.agentId,
                    sTime: this.filters.startDate,
                    eTime: this.filters.endDate,
                    schoolYear: this.filters.classyear,
                    order: resTabRef && resTabRef.schoolDataOrder ? resTabRef.schoolDataOrder : 'rs_upload_num desc',
                    phase: this.filters.phase == 0 ? "" : this.filters.phase,
                    keyword: this.keyWord
                };
                const query = Object.keys(params)
                    .map((key) => {
                        const value = params[key] == undefined ? "" : params[key];
                        return `${key}=${encodeURIComponent(value)}`;
                    })
                    .join("&");
                let iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = process.env.VUE_APP_APIURL + "/stats/bigscreenusage/getActiveBySchoolExport?" + query;
                iframe.onload = () => {
                    const responseText = iframe.contentDocument.body.innerText;
                    if (responseText) {
                        const msg = JSON.parse(responseText).msg;
                        this.$Message.error(msg);
                    }
                    document.body.removeChild(iframe);
                };
                document.body.appendChild(iframe);
            },
            /**
             * 点击切换详细数据
             */
            changeDataDetailsIndex(name) {
                let _this = this;
                _this.tabsName = name;
                _this.keyWord = "";
                if (!_this.isFilterReady) {
                    return;
                }
                _this.queryDataListDetails(name);
                _this.$nextTick(()=>{
                    if(_this.$refs.hwTabRef){
                        _this.$refs.hwTabRef.queryDataByFilter();
                    }
                })
            },
            /**
             * 搜索
             */
            handleSearch() {
                this.queryDataListDetails(this.tabsName);
            },
            /**
             * 请求数据
             */
            queryDataListDetails() {
                if (!this.isFilterReady) {
                    return;
                }
                if(this.activeType=='phase'){
                    this.getPhaseDataSummary();
                }else if(this.activeType=='school'){
                    this.getSchoolDataSummary();
                }else if(this.activeType=='subject'){
                    this.getSubjectDataSummary();
                }
            },
            /**
             * 筛选数据
             */
            filterData(filters) {
                if (this.contentObject.displayYearFilter && !filters.classyear) {
                    this.isFilterReady = false;
                    return;
                }
                this.isFilterReady = true;
                this.filters = filters;
                this.queryDataListDetails();
            },
            /**
             * 获取学段的数据概览
             */
            async getPhaseDataSummary() {
                let _this = this;
                let params = {
                    agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
                    sTime:_this.filters.startDate==''?'':_this.$utils.formatDate(new Date( _this.filters.startDate)),
                    eTime:_this.filters.endDate==''?'': _this.$utils.formatDate(new Date(_this.filters.endDate)),
                    gradeid: _this.filters.gradeId==0?(_this.filters.phaseGradeIds || ""):_this.filters.gradeId,
                    phase: _this.filters.phase==0?"":_this.filters.phase,
                    schoolYear: _this.filters.classyear,
                    keyword: _this.keyWord
                };
                let resultData = await findPhaseDataSummary(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.handleDataSummary(resultData);
            } ,
            /**
             * 获取学校的数据概览
             */
            async getSchoolDataSummary() {
                let _this = this;
                let params = {
                    agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
                    sTime: _this.filters.startDate,
                    eTime: _this.filters.endDate,
                    phase: _this.filters.phase==0?"":_this.filters.phase,
                    schoolYear: _this.filters.classyear,
                    keyword: _this.keyWord
                };
                let resultData = await findSchoolDataSummary(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.handleDataSummary(resultData);
                },
            /**
             * 获取学科的数据概览
             */
            async getSubjectDataSummary() {
                let _this = this;
                let params = {
                    agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
                    sTime: _this.filters.startDate,
                    eTime: _this.filters.endDate,
                    phase: _this.filters.phase==0?"":_this.filters.phase,
                    subjectId: _this.filters.subjectId==0?"":_this.filters.subjectId,
                    schoolYear: _this.filters.classyear,
                    keyword: _this.keyWord
                };
                let resultData = await findSubjectDataSummary(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.handleDataSummary(resultData);
            },
            /**
             * 处理数据
             */
            handleDataSummary(resultData){
                let _this=this;
                _this.dataSummaryMap=[];
                if (_this.tabsName=="hwTab") {
                    _this.dataSummaryMap = [
                        {
                            key: '作业布置数',
                            value: resultData[0].tea_hw_num == null ? 0 : resultData[0].tea_hw_num,
                            remindText: '老师已发送的作业次数'
                        }, {
                            key: '接收人数',
                            value: resultData[0].hw_stu_num == null ? 0 : resultData[0].hw_stu_num,
                            remindText: '每次作业接收人数的总和'
                        },
                        {
                            key: '提交人数',
                            value: resultData[0].hw_submit_num == null ? 0 : resultData[0].hw_submit_num,
                            remindText: '每次作业提交人数的总和'
                        }, {
                            key: '作业批改数',
                            value: resultData[0].hw_correct_num == null ? 0 : resultData[0].hw_correct_num,
                            remindText: '每次作业老师批改作业的总数'
                        }, {
                            key: '平均提交率',
                            value: resultData[0].hw_submi_rate == null ? 0 + "%" : _this.$utils.toDecimal(resultData[0].hw_submi_rate * 100).toString() + '%',
                            remindText: '提交人数/接收人数*100%'
                        }, {
                            key: '平均批改率',
                            value: resultData[0].hw_correct_rate == null ? 0 + "%" : _this.$utils.toDecimal(resultData[0].hw_correct_rate * 100).toString() + '%',
                            remindText: '批改作业数/提交人数*100%'
                        }
                    ]
                } else if(_this.tabsName=="microTab"){
                    _this.dataSummaryMap = [
                        {
                            key: '微课上传数',
                            value: resultData[0].cw_upload_num == null ? 0 : resultData[0].cw_upload_num,
                            remindText: '老师上传至网盘的微课总数'
                        },
                        {
                            key: '微课分享数',
                            value: resultData[0].cw_share_num == null ? 0 : resultData[0].cw_share_num,
                            remindText: '老师分享微课的总次数'
                        },
                        {
                            key: '微课查看数',
                            value: resultData[0].cw_read_num == null ? 0 : resultData[0].cw_read_num,
                            remindText: '每份微课的看懂人数和未看懂人数的总和'
                        },
                        {
                            key: '学生查看率',
                            value: resultData[0].cw_read_rate == null ? 0 + "%" : _this.$utils.toDecimal(resultData[0].cw_read_rate * 100).toString() + '%',
                            remindText: '(看懂人数+未看懂人数)/接收到微课的人数*100%'
                        },
                        {
                            key: '学生看懂率',
                            value: resultData[0].cw_understand_rate == null ? 0 + "%" :_this.$utils.toDecimal(resultData[0].cw_understand_rate * 100).toString() + '%',
                            remindText: '看懂人数/已看人数*100%'
                        }
                    ]
                }else if(_this.tabsName=="resTab"){
                    _this.dataSummaryMap = [
                        {
                            key: '资源上传数',
                            value: resultData[0].rs_upload_num == null ? 0 : resultData[0].rs_upload_num,
                            remindText: '老师上传至网盘的资源总数'
                        },
                        {
                            key: '资源分享数',
                            value: resultData[0].rs_share_num == null ? 0 : resultData[0].rs_share_num,
                            remindText: '老师分享资源的总次数'
                        },
                        {
                            key: '资源查看数',
                            value: resultData[0].rs_read_num == null ? 0 : resultData[0].rs_read_num,
                            remindText: '每份资源的看懂人数和未看懂人数的总和'
                        }, {
                            key: '学生查看率',
                            value: resultData[0].rs_read_rate == null ? 0 + "%" : _this.$utils.toDecimal(resultData[0].rs_read_rate * 100).toString() + '%',
                            remindText: '(看懂人数+未看懂人数)/接收到资源的人数*100%'
                        }, {
                            key: '学生看懂率',
                            value: resultData[0].rs_understand_rate == null ? 0 + "%" : _this.$utils.toDecimal(resultData[0].rs_understand_rate * 100).toString() + '%',
                            remindText: '看懂人数/已看人数*100%'
                        }
                    ]
                }else if(_this.tabsName=="studyTab"){
                    _this.dataSummaryMap = [
                        {
                            key: '发送次数',
                            value: resultData[0].inquiry_num == null ? 0 : resultData[0].inquiry_num,
                            remindText: '老师发送探究学习的总次数'
                        },
                        {
                            key: '动态数量',
                            value: resultData[0].inquiry_dynamic_num == null ? 0 : resultData[0].inquiry_dynamic_num,
                            remindText: '每一个探究学习动态数量的总和'
                        }, {
                            key: '接收人数',
                            value: resultData[0].inquiry_stu_num == null ? 0 : resultData[0].inquiry_stu_num,
                            remindText: '每一个探究学习接收人数的总和'
                        },
                        {
                            key: '参与人数',
                            value: resultData[0].inquiry_partake_num == null ? 0 : resultData[0].inquiry_partake_num,
                            remindText: '每一个探究学习参与人数的总和'
                        }, {
                            key: '参与率',
                            value: resultData[0].partake_rate == null ? 0 + "%" : _this.$utils.toDecimal(resultData[0].partake_rate * 100).toString() + '%',
                            remindText: '参与人数/接收人数*100%'
                        }
                    ]
                }
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .panel-box {
        background-image: url("../../../../assets/images/databoard/modal-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%
    }

    .data-tab-area {
        padding-top: 0;
    }

    .big-data-search-btn {
        background: #00CAAF !important;
        color: #fff;
        border-color: #00CAAF !important;
    }
</style>

<style lang="scss">
    .data-tab-area {
        .ivu-tabs-bar {
            border-bottom: 0;
            background: #f2f5f3;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
            height: 40px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
            height: 40px;
            margin-right: 1px;
            padding: 9px 16px 4px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
            height: 40px;
            color: #00caaf;
        }

        .ivu-tabs-nav .ivu-tabs-tab:hover {
            color: #00caaf;
        }

        .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
            border-color: #dcdee2 !important;
        }
    }

    .search-bar {
        .ivu-btn-primary {
            color: #fff;
            background-color: #00caaf;
            border-color: #00caaf;
        }
    }
</style>

